import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {NgbModal, NgbModalRef} from "@ng-bootstrap/ng-bootstrap";
import {AbstractControl, FormArray, FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import {MatTableDataSource} from "@angular/material/table";
import {Subject, Subscription, takeUntil} from "rxjs";
import {ToastrService} from "ngx-toastr";
import {SchoolProgramActivityModel} from "../../../../shared/models/school-program-activity-model";
import {SchoolProgramService} from "../../../../shared/services/school-program.service";
import {ThemePalette} from "@angular/material/core";
import { ActivatedRoute, Router } from '@angular/router';
import { ExtracurricularService } from 'src/shared/services/extracurricular.service';
import { AuthService } from 'src/shared/services/auth.service';
import { PathwayMappingService } from 'src/shared/services/pathway-mapping.service';
import { PathwayMapping } from 'src/shared/models/pathway-mapping.model';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { ResponseService } from 'src/shared/services/response-service.service';
import { TranslateService } from 'src/shared/services/translate.service';
import { PeriodService } from 'src/shared/services/period.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-activity-add',
  templateUrl: './activity-add.component.html',
  styleUrl: './activity-add.component.scss'
})
export class ActivityAddComponent implements OnInit, OnDestroy {
  @ViewChild('addActivity', {static: true}) public modalAddActivity: NgbModalRef;
  private destroy$ = new Subject<void>();

  heading = "Activity";
  loading: any = {}
  disableSpSelect = false;
  color: ThemePalette = 'primary';

  subsApprover: Subscription;

  currentPage = 1;
  schoolActivities: MatTableDataSource<any>;
  total = 0;
  currentAcademic = null;
  hasData = false;
  detailData: any;
  columnsToDisplay = ['activity_name','activity_description', 'participants', 'action'];
  newSchoolActivityForm: FormGroup;
  editActivityForm: FormGroup;
  checkApiRun: Subscription;
  yearLevelRelations: any;
  yearLevelRelationsSelected: any[] = [];
  yearLevelRelationsSelectedDetail: any[] = [];
  periodForYearLevel: number;

  activityDateInvalid = false;
  activityMaxRegistrationDateInvalid = false;

  disableButtonAdd = true;
  usingScoreRange = false;
  usingActivityRule = false;
  sessionIsOverriden = false;

  allPeriod = false;
  allScorePeriod = true;

  schoolDay = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];
  statusList = ['Inactive', 'Active', 'Hold'];
  selectedSchoolDay: string[] = [];
  session: number;

  // score & predicate
  scores: {
    score_name: string,
    score_detail: {
      minimum_score?: any,
      maximum_score?: any,
      predicate: string,
      description: string
    }[]
  }[] = [];

  totalFee = 0;

  approverList = [];
  supervisor = false;
  supervisorList = [];
  coach = false;
  coachList = [];
  searchSupervisor: string;
  searchCoach: string;

  sort = 'asc';
  orderBy = 'activity_name'
  yearLevelIds: any = null;

  studentSelectedGanjil = false;
  studentDeleteSelectedGanjil = false;
  selectedStudentIdGanjil: any = [];
  selectedtDeleteStudentIdGanjil: any = [];

  studentSelectedGenap= false;
  studentDeleteSelectedGenap: any = false;
  selectedtDeleteStudentIdGenap: any = [];
  participantDataGenap: any = null;
  checkedParticipantAll: any[] = [];
  checkedParticipantPeriod: any[] = [];
  scoreRangeByPeriod: { [key: string]: FormArray } = {};

  periodList: any = [];
  
  periodId: any = null;
  toggle: boolean = true;
  activityId: any = null;

  constructor(
    private schoolProgramService: SchoolProgramService,
    private rpSer: ResponseService,
    private exculService: ExtracurricularService,
    private toastr: ToastrService,
    private modalService: NgbModal,
    private formBuilder: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    public auth: AuthService,
    private pmService: PathwayMappingService,
    private periodService: PeriodService,
    private translate: TranslateService
  ) {
    this.auth.loadPermissions(true);
    this.translate.load('activity', 'extracurricular', 'scoring');
  }

  ngOnInit(): void {
    this.initForm();
    this.trackFormChanges();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
    if (this.checkApiRun) {
      this.checkApiRun.unsubscribe();
    }
    if (this.subsApprover) {
      this.subsApprover.unsubscribe();
    }
  }

  onCheckedParticipantsChange(payload: any, period: any = null): void {
    if (period) {
      if (payload === 'all') {
        this.checkedParticipantPeriod = this.checkedParticipantPeriod.map(p => {
          if (+p.period_id === +period.period_id) {
            return {
              ...p,
              participants: [],
              all: true
            }
          }
          return p;
        });
      } else {
        this.checkedParticipantPeriod = this.checkedParticipantPeriod.map(p => {
          if (+p.period_id === +period.period_id) {
            return {
              ...p,
              participants: payload.participants || [],
              all: false
            }
          }
          return p;
        });
      }

      const index = this.checkedParticipantPeriod.findIndex(p => +p.period_id === +period.period_id);
      if (index > -1) {
        this.checkedParticipantPeriod[index].participants = payload.participants;
      }
    } else {
      if (payload === 'all') {
        this.newSchoolActivityForm.controls['all_student_all_period'].setValue(true);
        return;
      } else {
        this.newSchoolActivityForm.controls['all_student_all_period'].setValue(false);
      }

      this.newSchoolActivityForm.controls['is_all_period'].setValue(false);
      this.checkedParticipantAll = payload.participants;
    }
  }

  changePeriodTab() {

  }

  initForm() {
    this.newSchoolActivityForm = this.formBuilder.group({
      'academic_year': new FormControl(null),
      'school_location_id': new FormControl(null),
      'school_level_id': new FormControl(null),
      'school_program_id': new FormControl(null),
      'school_program_category_id': new FormControl(null),
      'activity_name': new FormControl(null),
      'activity_description': new FormControl(null),
      'year_level_id':new FormControl(null),
      'activity_schedule': this.formBuilder.array([]),
      'start_date': new FormControl(null),
      'end_date': new FormControl(null),
      'sessions': new FormControl(0).disable(),
      'session_override': new FormControl(null),
      'using_session_override': new FormControl(null),
      'max_registration_date': new FormControl(null),
      'min_participant': new FormControl(null),
      'max_participant': new FormControl(null),
      'participation_fee': new FormControl(null),
      'user_id_approver': new FormControl(null),
      'activity_score': new FormControl(null),
      'supervisor': new FormControl([]),
      'coach': new FormControl([]),
      'status': new FormControl('Active'),
      'score_range': this.formBuilder.array([]),
      'coach_fee': new FormControl(null),
      'equipment_fee': new FormControl(null),
      'venue_fee': new FormControl(null),
      'other_fee': new FormControl(null),
      'name_on_report_card': new FormControl(null),
      'gender': new FormControl('all'),
      'all_student_all_period': new FormControl(false),
      'is_all_period': new FormControl(false),
      // 'rule_per_year_level': this.formBuilder.array([]),
      // 'using_rule_per_year_level': new FormControl(null),
    });
    this.addScore();
    this.schoolDay.forEach(day => {
      this.addSchedule(day);
    });
    this.getPeriodList();
  }

  setGender(gender: 'all' | 'M' | 'F'): void {
    this.newSchoolActivityForm.get('gender')?.setValue(gender);
  }

  get scoreRange(): FormArray {
    return this.newSchoolActivityForm.get('score_range') as FormArray;
  }

  getScoreRangeDetail(index: number): FormArray {
    return this.scoreRange.at(index).get('score_detail') as FormArray;
  }

  getScoreRange(periodId: any = null): FormArray {
    if (periodId === null || periodId === undefined) {
      return this.scoreRange;
    }
    this.ensureScoreRangeForPeriod(periodId);
    return this.scoreRangeByPeriod[periodId];
  }

  getScoreRangeDetailByPeriod(index: number, periodId: any = null): FormArray {
    return this.getScoreRange(periodId).at(index).get('score_detail') as FormArray;
  }

  get isScoreRangeMultiple(): boolean {
    if (this.allScorePeriod) {
      return this.scoreRange.controls.some(score => (score.get('score_detail') as FormArray).length > 1);
    } else {
      return this.periodList.some(period => {
        const scoreRange = this.getScoreRange(period.period_id);
        return scoreRange.controls.some(score => (score.get('score_detail') as FormArray).length > 1);
      });
    }
  }

  get ruleParticipantPerYearLevel(): FormArray {
    return this.newSchoolActivityForm.get('rule_per_year_level') as FormArray;
  }

  getPeriodList() {
    this.periodService.getPeriods().subscribe((response: any) => {
      this.periodList = response.result.data;
      this.checkedParticipantPeriod = [...this.periodList.map((period: any) => {
        return {
          period_id: period.period_id,
          participants: [],
          all: false
        }
      })];
      this.periodList.forEach((period: any) => this.ensureScoreRangeForPeriod(period.period_id));
    });
  }

  createScoreGroup() {
    const scoreGroup = this.formBuilder.group({
      score_name: new FormControl(null),
      score_detail: this.formBuilder.array([])
    });

    return scoreGroup;
  }

  ensureScoreRangeForPeriod(periodId: any) {
    if (!this.scoreRangeByPeriod[periodId]) {
      this.scoreRangeByPeriod[periodId] = this.formBuilder.array([]);
      this.addScore(periodId);
    }
  }

  addScore(periodId: any = null) {
    const scoreRange = this.getScoreRange(periodId);
    scoreRange.push(this.createScoreGroup());
    this.addScoreDetail(scoreRange.length - 1, periodId);
  }

  getRowspan(index: number, periodId: any = null): number {
    const details = this.getScoreRangeDetailByPeriod(index, periodId);
    return details.length > 0 ? details.length + 1 : 1;
  }

  removeScore(periodId: any = null) {
    const scoreRange = this.getScoreRange(periodId);
    scoreRange.removeAt(scoreRange.length - 1);
  }

  addScoreDetail(index: number, periodId: any = null) {
    let detailGroup;
    if (this.usingScoreRange) {
        detailGroup = this.formBuilder.group({
            minimum_score: new FormControl(null, Validators.required),
            maximum_score: new FormControl(null, Validators.required),
            predicate: new FormControl(null),
            description: new FormControl(null),
        });
    } else { 
        detailGroup = this.formBuilder.group({
            minimum_score: new FormControl(null),
            maximum_score: new FormControl(null),
            predicate: new FormControl(null),
            description: new FormControl(null),
        });
    }
    this.getScoreRangeDetailByPeriod(index, periodId).push(detailGroup);
  }

  removeScoreDetail(scoreIndex: number, detailIndex: number, periodId: any = null) {
    this.getScoreRangeDetailByPeriod(scoreIndex, periodId).removeAt(detailIndex);
  }

  convertToFormControl(absCtrl: AbstractControl | null): FormControl {
    const ctrl = absCtrl as FormControl;
    return ctrl;
  }
  

  click(){
    console.log(this.newSchoolActivityForm.value);
  }

  get activitySchedule(): FormArray {
    return this.newSchoolActivityForm.get('activity_schedule') as FormArray;
  }

  addSchedule(day: string) {
    const scheduleArray = this.newSchoolActivityForm.get('activity_schedule') as FormArray;
    scheduleArray.push(this.formBuilder.group({
      day: [day],
      check: [false],
      time_start: [''],
      time_end: [''],
      venue: [''],
      equipment: ['']
    }));
  }

  onChangeScorePredicate() {
    this.usingScoreRange = !this.usingScoreRange;
    this.newSchoolActivityForm.controls['activity_score'].setValue(this.usingScoreRange ? true : false);
    this.scoreRange.clear();
    this.addScore();
    this.scoreRangeByPeriod = {};
    this.periodList.forEach((period: any) => this.ensureScoreRangeForPeriod(period.period_id));
  }

  onToggleAllScorePeriod() {
    this.allScorePeriod = !this.allScorePeriod;
    this.periodList.forEach((period: any) => this.ensureScoreRangeForPeriod(period.period_id));
  }

  onChangeActivityRuleBox() {
    this.usingActivityRule = !this.usingActivityRule;
    this.newSchoolActivityForm.controls['using_rule_per_year_level'].setValue(this.usingActivityRule ? true : false);
    console.log(this.ruleParticipantPerYearLevel.invalid)
  }

  getSupervisor() {
    this.supervisorList = [];
    this.schoolProgramService.getSupervisorList(this.newSchoolActivityForm.get('school_location_id')?.value).subscribe({
      next: (response: any) => {
        if (response.status) {
          this.supervisorList = response.data;
        } else {
          this.rpSer.showAddError(response.message ? response.message : 'Failed to load supervisor list. Please try again.');
        }
      },
      error: (error: any) => {
        this.rpSer.showAddError();
      }
    });
  }

  getCoach() {
    this.coachList = [];
    const id = this.newSchoolActivityForm.get('school_location_id')?.value;
    this.schoolProgramService.getCoachList(id).subscribe({
      next: (response: any) => {
        if (response.status) {
          this.coachList = response.data;
        } else {
          this.rpSer.showAddError(response.message ? response.message : 'Failed to load coach list. Please try again.');
        }
      },
      error: (error: any) => {
        this.rpSer.showAddError();
      }
    })
  }

  trackFormChanges() {
    this.newSchoolActivityForm.valueChanges.pipe(
      takeUntil(this.destroy$)
    ).subscribe((currentValue: any) => {
      let ruleInvalid = false;
      if (this.usingActivityRule) {
        ruleInvalid = this.ruleParticipantPerYearLevel.invalid;
      } else {
        ruleInvalid = this.newSchoolActivityForm.get('min_participant')?.value === null ||
                      this.newSchoolActivityForm.get('max_participant')?.value === null;
      }
      this.disableButtonAdd =
          !this.newSchoolActivityForm.get('activity_name')?.value ||
          !this.newSchoolActivityForm.get('school_program_category_id')?.value ||
          !this.newSchoolActivityForm.get('year_level_id')?.value ||
          !this.newSchoolActivityForm.get('start_date')?.value ||
          !this.newSchoolActivityForm.get('end_date')?.value ||
          !this.newSchoolActivityForm.get('max_registration_date')?.value ||
          ruleInvalid ||
          !this.newSchoolActivityForm.get('status')?.value ||
          (this.sessionIsOverriden && !this.newSchoolActivityForm.get('session_override')?.value) ||
          this.activityDateInvalid || 
          this.activityMaxRegistrationDateInvalid;
    });
  }
  onChangeAcademicYear(item: any, action = 'list') {
    this.newSchoolActivityForm.controls['academic_year'].markAsTouched();
    this.newSchoolActivityForm.controls['academic_year'].setValue(item ? item.academic_year : null);
    this.periodForYearLevel = item.period_id;
    if (!this.periodForYearLevel) {
      this.yearLevelRelations = [];
    }
  }

  onChangeSchoolLevel(item: any, action = 'list') {
    this.newSchoolActivityForm.controls['school_level_id'].markAsTouched();
    this.newSchoolActivityForm.controls['school_level_id'].setValue(item ? item.school_level_id : null);

    this.newSchoolActivityForm.controls['school_location_id'].markAsTouched();
    this.newSchoolActivityForm.controls['school_location_id'].setValue(item ? item.school_location_id : null);

    this.newSchoolActivityForm.controls['year_level_id'].setValue(null);
    if (this.newSchoolActivityForm.controls['school_location_id'].value) {
      this.getSupervisor();
      this.getCoach();
    }
    if (this.newSchoolActivityForm.controls['school_location_id'].value) {
      this.getNewPathwayMapping();
    } else {
      this.yearLevelRelations = [];
    }
    // this.ruleParticipantPerYearLevel.clear();
  }

  // onChangeYearLevel(item: any, action = 'list') {
  //   this.newSchoolActivityForm.controls['year_level_id'].markAsTouched();
  //   const data = item.map((i: { year_level_id: any; }) => i.year_level_id);
  //   this.newSchoolActivityForm.controls['year_level_id'].setValue(data.length > 0 ? data : null);
  //   this.newSchoolActivityForm.controls['school_program_id'].setValue(null);
  // }

  onChangeYearLevelByCheckbox(event: any, item: any) {
    if (event.checked) {
      this.yearLevelRelationsSelected = [
        ...this.yearLevelRelationsSelected,
        item.year_level_id
      ];
      this.yearLevelRelationsSelectedDetail.push(item);
      // this.addRulePerYearLevel(item.year_level_id, item.description);
    } else {
      this.yearLevelRelationsSelected = this.yearLevelRelationsSelected.filter(
        id => id !== item.year_level_id
      );
      this.yearLevelRelationsSelectedDetail.splice(this.yearLevelRelationsSelectedDetail.indexOf(item), 1);
      // this.removeRulePerYearLevel(item.year_level_id);
    }
    this.disableSpSelect = true;
    this.approverList = [];
    this.newSchoolActivityForm.controls['school_program_id'].setValue(null);
    this.newSchoolActivityForm.controls['school_program_category_id'].setValue(null);
    this.insertYearLevel();
  }

  insertYearLevel() {
    this.newSchoolActivityForm.controls['year_level_id'].markAsTouched();
    this.newSchoolActivityForm.controls['year_level_id'].setValue(null);
    this.newSchoolActivityForm.controls['year_level_id'].setValue(this.yearLevelRelationsSelected.length > 0 ? this.yearLevelRelationsSelected : null);
    this.newSchoolActivityForm.controls['school_program_id'].setValue(null);
    if (this.newSchoolActivityForm.controls['school_program_id'].value) {
      this.getSchoolActivities();
      // this.getActivityParticipantApprover();
    }
    this.disableSpSelect = false;
  }

  addRulePerYearLevel(yearLevelId: number, desc: string) {
    const group = this.formBuilder.group({
      year_level_id: new FormControl(yearLevelId),
      description: new FormControl(desc),
      max_participant: new FormControl(null, Validators.required),
      min_participant: new FormControl(null, Validators.required),
    });
    this.ruleParticipantPerYearLevel.push(group);
  }

  removeRulePerYearLevel(yearLevelId: number) {
    const index = this.ruleParticipantPerYearLevel.value.findIndex((g: any) => g.year_level_id === yearLevelId);
    if (index > -1) {
      this.ruleParticipantPerYearLevel.removeAt(index);
    }
  }

  getNewPathwayMapping() {
    this.pmService.yearLevelNoAcademic({
      academic_year: this.newSchoolActivityForm.controls['academic_year'].value,
      school_location_id: this.newSchoolActivityForm.controls['school_location_id'].value,
      school_level_id: this.newSchoolActivityForm.controls['school_level_id'].value,
      period_id: this.periodForYearLevel,
    })
      .subscribe((response: PathwayMapping) => {
        // @ts-ignore
        if (response.status) {
          // @ts-ignore
          this.yearLevelRelations = response.data.slice();
          // this.yearLevelRelations.forEach((element: { selected: boolean; }) => {
          //   element.selected = false;
          // });
        } else {
          // @ts-ignore
          this.toastr.error('[' + this.heading + '] ' + response['message'], 'Invalid Response');
        }
      }, (error: any) => {
        this.toastr.error('[' + this.heading + '] Cannot access server endpoint!', 'Connection Error');
      });
  }

  onChangeSchoolProgram(item: any, action = 'list') {
    this.newSchoolActivityForm.controls['school_program_id'].markAsTouched();
    this.newSchoolActivityForm.controls['school_program_id'].setValue(item ? item.school_program_id : null);

    this.newSchoolActivityForm.controls['school_program_category_id'].setValue(null);
    if (this.newSchoolActivityForm.controls['school_program_id'].value) {
      this.getSchoolActivities();
    }
  }

  onChangeSchoolProgramCategory(item: any, action = 'list') {
    this.newSchoolActivityForm.controls['school_program_category_id'].markAsTouched();
    this.newSchoolActivityForm.controls['school_program_category_id'].setValue(item ? item.school_program_category_id : null);
  }

  onChangeApprover(item: any) {
    this.newSchoolActivityForm.controls['user_id_approver'].markAsTouched();
    this.newSchoolActivityForm.controls['user_id_approver'].setValue(item ? item.user_id : null);
  }

  onChangeCoach(item: any) {
    this.newSchoolActivityForm.controls['coach'].markAsTouched();
    const data = item.map((i: { user_id: any; }) => i.user_id);
    this.newSchoolActivityForm.controls['coach'].setValue(data.length > 0 ? data : null);
  }

  onChangeSupervisor(item: any) {
    this.newSchoolActivityForm.controls['supervisor'].markAsTouched();
    const data = item.map((i: { staff_id: any; }) => i.staff_id);
    this.newSchoolActivityForm.controls['supervisor'].setValue(data.length > 0 ? data : null);
  }

  onChangeStatus(item: any) {
    this.newSchoolActivityForm.controls['status'].markAsTouched();
    this.newSchoolActivityForm.controls['status'].setValue(item ? item : null);
  }

  getSchoolActivities () {
    this.loading.list = true;
    if (this.checkApiRun) {
      this.checkApiRun.unsubscribe();
    }
    this.checkApiRun = this.schoolProgramService.getSchoolProgramActivity({
      academic_year: this.newSchoolActivityForm.get('academic_year')?.value,
      school_program_id: this.newSchoolActivityForm.get('school_program_id')?.value,
      school_program_category_id: this.newSchoolActivityForm.get('school_program_category_id')?.value,
      page: this.currentPage,
      pagination: true,
      sort: this.sort,
      orderBy: this.orderBy,
      year_level_id: this.newSchoolActivityForm.get('year_level_id')?.value,
      approved: true
    }).subscribe(
      (response: SchoolProgramActivityModel) => {
        // @ts-ignore
        if (response['status']) {
          // @ts-ignore
          this.schoolActivities = response['data'].slice();
          // @ts-ignore
          this.total = response['meta']['total'];
          this.hasData = this.total > 0;
          this.loading.list = false;
        } else {
          // @ts-ignore
          this.toastr.error('[' + this.heading + '] ' + response['message'], 'Invalid Response');
          this.loading.list = false;
        }
      },
      error => {
        this.toastr.error('[' + this.heading + '] Cannot access server endpoint!', 'Connection Error');
        this.loading.list = false;
      });
  }

  onSubmitAddActivity() {
    let data = this.newSchoolActivityForm.value;

    // logic participants
    if (this.allPeriod && data.all_student_all_period) {
      this.checkedParticipantPeriod = this.checkedParticipantPeriod.map(p => {
        return {
          ...p,
          participants: [],
          all: true
        }
      });
    } else if (this.allPeriod && !data.all_student_all_period) {
      this.checkedParticipantPeriod = this.checkedParticipantPeriod.map(p => {
        return {
          ...p,
          participants: this.checkedParticipantAll,
          all: false
        }
      });
    }

    data = {
      ...data,
      score_range: this.buildScoreRangePayload(),
      period_participants: this.checkedParticipantPeriod,
      all_participants: this.checkedParticipantAll
    }

    data.gender = data.gender === 'all' ? null : data.gender;

    if (this.isScoreRangeInvalid()) {
      Swal.fire({
        title: 'Invalid Score Range',
        text: 'Please complete all required fields in score range.',
        icon: 'warning',
        confirmButtonText: 'OK',
      });
      return;
    }

    if (((data.period_participants.length > 0 && data.period_participants[0].participants.length > 0) || data.all_participants.length > 0) && data.participation_fee > 0 && this.auth.permissions['SCHOOL_PROGRAM_ADD_PARTICIPANT_BYPASS_PAYMENT']) {
      Swal.fire({
        title: 'Bypass Payment Confirmation',
        text: 'Do you want to bypass payment for added participants?',
        icon: 'question',
        showCancelButton: true,
        showCloseButton: true,
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        allowOutsideClick: false,
      }).then((result) => {
        if (result.dismiss === Swal.DismissReason.close) {
          return;
        }
        data.bypass_payment = result.isConfirmed;
        this.submitAddActivity(data);
      });
    } else {
      this.submitAddActivity(data);
    }
  }

  submitAddActivity(data: any) {
    this.schoolProgramService.createSchoolProgramActivity(data).subscribe(
        (response: any) => {
          if (response['status']) {
            this.rpSer.showAddSuccess('The school program activity has been added successfully.');
            this.router.navigate(['../'], {relativeTo: this.route});
          } else {
            this.rpSer.showAddError(response.message ? response.message : 'Failed to add the school program activity. Please try again.');
          }
        },
        (error: any) => {
          this.rpSer.showAddError();
        }
    );
  }

  buildScoreRangePayload() {
    const periodIds = this.allScorePeriod ? [null] : this.periodList.map((period: any) => period.period_id);

    return periodIds.flatMap((periodId: any) => {
      return this.getScoreRange(periodId).value.map((score: any) => ({
        ...score,
        period_id: periodId
      }));
    });
  }

  isScoreRangeInvalid(): boolean {
    if (this.allScorePeriod) {
      return this.scoreRange.invalid;
    }

    return this.periodList.some((period: any) => this.getScoreRange(period.period_id).invalid);
  }

  onCancel() {
    this.selectedtDeleteStudentIdGanjil = [];
    this.selectedStudentIdGanjil = [];
    this.activityId = null;
    this.modalService.dismissAll();
  }

  sessionCount() {
    const start = this.newSchoolActivityForm.controls['start_date'].value;
    const end = this.newSchoolActivityForm.controls['end_date'].value;
    if (start && end) {
      let sessionCounter = 0;
      for (var d = new Date(start); d <= new Date(end); d.setDate(d.getDate() + 1)) {
        for (let i = 0; i < this.selectedSchoolDay.length; i++) {
          if (d.toString().split(' ')[0] === this.selectedSchoolDay[i].substring(0,3)) {
            sessionCounter++;
          }
        }
      }
      this.newSchoolActivityForm.patchValue({sessions: sessionCounter});
    } else {
      this.newSchoolActivityForm.patchValue({sessions: 0});
    }
  }

  onToogleSessionOverride() {
    this.sessionIsOverriden = !this.sessionIsOverriden;
    this.newSchoolActivityForm.controls['using_session_override'].setValue(this.sessionIsOverriden ? true : false);
  }

  onBack() {
    this.router.navigate(['../'], {relativeTo: this.route});
  }

  // getActivityParticipantApprover() {

  //   if (this.subsApprover) {
  //     this.subsApprover.unsubscribe();
  //   }

  //   this.loading.approver = true;
  //   this.newSchoolActivityForm.controls['user_id_approver'].setValue(null);

  //   this.subsApprover = this.schoolProgramService.getActivityParticipantApprover(this.newSchoolActivityForm.get('school_location_id')?.value, {year_level_id : this.newSchoolActivityForm.get('year_level_id')?.value, academic_year: this.newSchoolActivityForm.get('academic_year')?.value})
  //     .subscribe((response: any) => {
  //       if (response.status) {
  //         this.approverList = response.data;
  //       } else {
  //         this.rpSer.showAddError(response.message ? response.message : 'Failed to load approver list. Please try again.');
  //       }
  //       this.loading.approver = false;
  //     }, error => {
  //       this.rpSer.showAddError();
  //       this.loading.approver = false;
  //     });
  // }

  switchSupervisor() {
    this.supervisor = !this.supervisor;
  }

  switchCoach() {
    this.coach = !this.coach;
  }

  onChangeFeesParticipationFee() {
    if (this.newSchoolActivityForm.controls['participation_fee'].value === '') {
      this.newSchoolActivityForm.controls['participation_fee'].setValue(0);
    }
  }

  onChangeFees() {
    if (this.newSchoolActivityForm.controls['equipment_fee'].value === '') {
      this.newSchoolActivityForm.controls['equipment_fee'].setValue(0);
    }
    if (this.newSchoolActivityForm.controls['venue_fee'].value === '') {
      this.newSchoolActivityForm.controls['venue_fee'].setValue(0);
    }
    if (this.newSchoolActivityForm.controls['other_fee'].value === '') {
      this.newSchoolActivityForm.controls['other_fee'].setValue(0);
    }
    if (this.newSchoolActivityForm.controls['coach_fee'].value === '') {
      this.newSchoolActivityForm.controls['coach_fee'].setValue(0);
    }
    this.totalFee = 
    this.newSchoolActivityForm.controls['equipment_fee'].value +
    this.newSchoolActivityForm.controls['venue_fee'].value +
    this.newSchoolActivityForm.controls['other_fee'].value +
    this.newSchoolActivityForm.controls['coach_fee'].value;
  }

  onChangeSchoolDay(selectedDays: string[]) {
    if (selectedDays.length === 0) {
      this.activitySchedule.clear();
      this.selectedSchoolDay = [];
    }
    selectedDays.forEach(day => {
      if (!this.selectedSchoolDay.includes(day)) {
        this.addSchedule(day);
        this.selectedSchoolDay.push(day);
      }
    });
    if (this.selectedSchoolDay.length !== selectedDays.length) {
      this.selectedSchoolDay.forEach((schoolday, index) => {
        if (!selectedDays.includes(schoolday)) {
          this.activitySchedule.removeAt(index);
        }
      });
    }
    this.sessionCount();
  }

  onChangeSchoolDayByCheckbox(event: any, index: number) {
    const scheduleArray = this.newSchoolActivityForm.get('activity_schedule') as FormArray;
    scheduleArray.at(index).patchValue({ check: event.checked });
    if (event.checked) {
      this.selectedSchoolDay.push(scheduleArray.at(index).value.day);
    } else {
      this.selectedSchoolDay.splice(this.selectedSchoolDay.indexOf(scheduleArray.at(index).value.day), 1);
    }
    this.sessionCount();
  }
  

  checkDayInList(index: number) {
    this.schoolDay[index];
    return this.selectedSchoolDay.includes(this.schoolDay[index]);
  }

  changeActivityDate() {
    this.activityDateInvalid = this.newSchoolActivityForm.get('start_date')?.value > this.newSchoolActivityForm.get('end_date')?.value;
    this.activityMaxRegistrationDateInvalid = this.newSchoolActivityForm.get('max_registration_date')?.value > this.newSchoolActivityForm.get('end_date')?.value;
    this.sessionCount();
  }

  onToggleAllPeriod() {
    this.allPeriod = !this.allPeriod;
    if (this.allPeriod) {
      this.newSchoolActivityForm.controls['is_all_period'].setValue(true);
    } else {
      this.newSchoolActivityForm.controls['is_all_period'].setValue(false);
    }

    // reset
    this.checkedParticipantAll = [];
    this.checkedParticipantPeriod = this.checkedParticipantPeriod.map(p => {
      return {
        ...p,
        participants: [],
        all: true
      }
    });
  }
}
